import React, { useContext, useState, useRef, useEffect } from "react";
import { isEmpty, isNull } from "lodash";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import "../../../styles/components/CommunicationCard.scss";
import { Formik, Field } from "formik";
import {
  ManageCommunicationLayout,
  FieldInput,
  CommunicationCard,
  FieldDropSide,
  SearchableList,
  FormControlSearch,
  LoaderWrapper,
  Dropside,
  MultiSelectDropdown,
} from "../../../components";
import {
  manageCommunicationFormNames,
  formFields,
  getPathWithParam,
  MANAGE_COMMUNICATION_ROUTES,
  FLOW_TYPES,
  channelForCommunication,
  toMultiSelectValueById,
  CategoryOptions,
} from "../../../utils";
import { Link } from "react-router-dom";
import { useRequest, useDeepEffect } from "../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import {
  manageCommunicationStore,
  setCommunicationLocalCache,
} from "../../../contexts";
import {
  getPlanList,
  getCommunicationsBasedOnSelectedPlan,
  getEventsList,
} from "../../../services";

const typeOptions = [
  { label: "All", value: null },
  { label: "Event", value: 2 },
  { label: "Schedule", value: 1 },
];
const PlanLevelCommunicationContainer = (props) => {
  const { history } = props;
  const [toggle, setToggle] = useState(false);
  const { state, dispatch } = useContext(manageCommunicationStore);
  const [initialValues, setInitialValues] = useState({});
  const formName = manageCommunicationFormNames.PLAN_LEVEL_COMMUNICATION;
  const fields = formFields[formName];
  const [loading, setLoading] = useState(false);
  const [isNonCommunicationMapped, setIsNonCommunicationMapped] = useState(
    false
  );
  const [data, setData] = useState([]);
  const [eventsList, setEventsList] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(0);
  const [typeName, setTypeName] = useState("Events");
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const append = useRef(false);
  const numberOfRecordsToFetch = 20;
  const [request, setRequest] = useState({
    from: 0,
    offset: numberOfRecordsToFetch,
  });
  const [clearSearchVal, setClearSearchVal] = useState(false);
  const communictaionLables = [
    { label: "Event name", classname: "Non-card-label m-left" },
    { label: "Event Category", classname: "Non-card-label m-middle" },
    { label: "Configured Communication", classname: "Non-card-label m-right" },
  ];
  const communictaionNotMappedLables = [
    { label: "Event name", classname: "Non-card-non-mapped-label m-left" },
    {
      label: "Event Category",
      classname: "Non-card-non-mapped-label m-middle",
    },
    { label: "", classname: "Non-card-non-mapped-label m-right" },
  ];
  const defaultSeachRequest = {
    search: "",
    from: 0,
    offset: numberOfRecordsToFetch,
  };

  useEffect(() => {
    dispatch(
      setCommunicationLocalCache({
        model: "typeOptions",
        data: typeOptions,
      })
    );
    setLoading(true);
    getPlanList(0)
      .then((response) => {
        setLoading(false);
        setPlanList(
          response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          })
        );
        setInitialValues({ search: "", [fields.planId]: response[0].id });
        setSelectedPlan(response[0].id);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);
  useDeepEffect(() => {
    if (selectedPlan === 0) return;
    setLoading(true);
    getEventsList().then((response) =>
      setEventsList(
        response.map((item) => {
          return {
            label: item.name,
            value: item.id,
            eventCategory: item.eventCategory,
            metaData: item.metaData,
          };
        })
      )
    );
    getCommunication(request);
  }, [selectedPlan, request]);

  const getCommunication = (request) => {
    setLoading(true);
    getCommunicationsBasedOnSelectedPlan({
      search: "",
      planId: selectedPlan,
      ...request,
    })
      .then((response) => {
        setLoading(false);
        if (response?.length < numberOfRecordsToFetch)
          setStopInfiniteScroll(true);
        if (append.current) setData((prev) => [...prev, ...response]);
        else setData(response);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const filterEvents = eventsList.filter((el) => {
    return !data.find((element) => {
      return element.eventOrScheduleName === el.label;
    });
  });
  const onFormSubmit = (values) => {
    append.current = false;
    setStopInfiniteScroll(false);
    setRequest({
      ...values,
      eventName: isNull(values.eventName) ? null : values.eventName,
      from: 0,
      offset: numberOfRecordsToFetch,
    });
    setClearSearchVal(false);
  };
  return (
    <Formik
      initialValues={{
        ...initialValues,
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        let st1 = "col-md-2";
        return (
          <ManageCommunicationLayout pageName="Plan Communication">
            <Formik
              initialValues={{
                ...initialValues,
              }}
              onSubmit={onFormSubmit}
              enableReinitialize
            >
              {({
                handleChange,
                setFieldValue,
                handleSubmit,
                setValues,
                values,
                ...rest
              }) => {
                return (
                  <LoaderWrapper isLoading={loading} className="noScrollBar">
                    <Form
                      autoComplete="off"
                      className="h-100"
                      onSubmit={handleSubmit}
                      validated={!isEmpty(rest.errors)}
                    >
                      <div className="PlanLevelContainer">
                        <div className="header1">
                          {
                            <div>
                              <div className="ft-12 lh-19 mb-5 ftwt-500 dark">
                                Search
                                <span
                                  style={{
                                    padding: "0.05rem 0.3rem",
                                    fontsize: "0.65rem",
                                    color: "#828282",
                                  }}
                                >
                                  (Optional)
                                </span>
                              </div>
                              <Form>
                                <div style={{ height: "30px" }}>
                                  <InputGroup>
                                    <InputGroup.Prepend>
                                      <InputGroup.Text className="plan-search-button">
                                        <Image
                                          src="/assets/icons/svg/search.svg"
                                          width="14px"
                                        />
                                      </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControlSearch
                                      size="smd"
                                      type="text"
                                      label="Search"
                                      screen = "communication"
                                      //className="plan-search-box pad-left-search"
                                      placeholder="Event, Communication"
                                      clearSearchValue={clearSearchVal}
                                      onChange={(e) => {
                                        setFieldValue(
                                          fields.search,
                                          e.target.value
                                        );
                                        setClearSearchVal(false);
                                      }}
                                    />
                                  </InputGroup>
                                </div>
                              </Form>
                            </div>
                          }
                          <div className="ml-2">
                            <Field
                              label="Plan Name"
                              name={fields.planId}
                              value={values[fields.planId]}
                              direction="bottom"
                              placeholder="All"
                              options={planList}
                              size="smd"
                              isRequired
                              popupContent={
                                <SearchableList
                                  label="Select Plan name"
                                  options={planList}
                                  onSelect={(value, ind) =>
                                    setValues({
                                      ...values,
                                      [fields.planId]: value,
                                    })
                                  }
                                  selectedValue={values[fields.planId]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          </div>
                          <div className="ml-2">
                            <Field
                              label="Event Category"
                              name={fields.eventCategory}
                              value={values[fields.eventCategory]}
                              direction="bottom"
                              placeholder="Event Category"
                              title="Event Category"
                              size="smd"
                              options={CategoryOptions}
                              popupContent={
                                <SearchableList
                                  label="Select event category"
                                  height="150px"
                                  options={CategoryOptions}
                                  onSelect={(value) => {
                                    setValues({
                                      ...values,
                                      [fields.eventCategory]: value,
                                    });
                                    setFieldValue(fields.eventName, 0);
                                  }}
                                  selectedValue={values[fields.eventCategory]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          </div>
                          <div className="ml-2">
                            <Field
                              label="Event Name"
                              name={fields.eventName}
                              direction="bottom"
                              value={values[fields.eventName]}
                              changePositiononSpace={false}
                              placement="bottom-start"
                              placeholder="Event Name"
                              size="smd"
                              options={eventsList.filter(
                                (x) => x.eventCategory == values.eventCategory
                              )}
                              popupContent={
                                <SearchableList
                                  width="300px"
                                  height="200px"
                                  label="Select Type"
                                  options={eventsList.filter(
                                    (x) =>
                                      x.eventCategory == values.eventCategory
                                  )}
                                  onSelect={(value) =>
                                    setValues({
                                      ...values,
                                      [fields.eventName]: value,
                                    })
                                  }
                                  selectedValue={values[fields.eventName]}
                                />
                              }
                              component={FieldDropSide}
                            />
                            {/* <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "7px",
                                marginLeft: "0.5rem",
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: "5px",
                                  fontSize: "12px",
                                  color: "#000000",
                                  fontWeight: "500",
                                  lineHeight: "1.23",
                                }}
                              >
                                Event name
                              </div>
                              <div
                                className="event-name-width"
                                style={{ width: "170px" }}
                              >
                                <Dropside
                                  // size="xs"
                                  leftOffset={120}
                                  direction="bottom"
                                  name={fields.eventName}
                                  isRequired
                                  label="Event Name"
                                  placeholder="Event Name"
                                  options={eventsList.filter(
                                    (x) =>
                                      x.eventCategory == values.eventCategory
                                  )}
                                  isMultiSelect
                                  value={toMultiSelectValueById(
                                    values[fields.eventName],
                                    eventsList.filter(
                                      (x) =>
                                        x.eventCategory == values.eventCategory
                                    )
                                  )}
                                  popupContent={
                                    <MultiSelectDropdown
                                      label="Select Event Name"
                                      hideSelectedOptions="FALSE"
                                      width="305px"
                                      placeholder="Search"
                                      height="190px"
                                      maxHeight="200px"
                                      options={eventsList.filter(
                                        (x) =>
                                          x.eventCategory ==
                                          values.eventCategory
                                      )}
                                      onSelect={(value) => {
                                        setFieldValue(fields.eventName, value);
                                        //setSelectedPlans(value);
                                      }}
                                      name={"eventName"}
                                      value={values[fields.eventName]}
                                      isTypeAhead={true}
                                      isClear={true}
                                    />
                                  }
                                />
                              </div>
                            </div> */}
                          </div>
                          {/* <div>
                            <Field
                              label="Type"
                              name={fields.type}
                              value={values[fields.type]}
                              direction="bottom"
                              placeholder="All"
                              size="sm"
                              options={typeOptions}
                              popupContent={
                                <SearchableList
                                  label="Select Type"
                                  options={typeOptions}
                                  onSelect={(value) =>
                                    setValues({ ...values, type: value })
                                  }
                                  selectedValue={values[fields.type]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          </div> */}
                          <div className="element ml-2">
                            <Button
                              variant="secondary"
                              onClick={() => {
                                setClearSearchVal(true);
                                setFieldValue("search", null);
                                setFieldValue(fields.planId, selectedPlan);
                                setFieldValue(fields.eventCategory, 0);
                                setFieldValue(fields.eventName, 0);
                                getCommunication(defaultSeachRequest);
                              }}
                              className=" padding-search-clear-filters"
                            >
                              Clear
                            </Button>
                          </div>
                          <div className="element ml-2">
                            <Button
                              type="submit"
                              variant="secondary"
                              className=" padding-search-clear-filters"
                            >
                              Search
                            </Button>
                          </div>
                        </div>
                        {/* {data.length > 0 ? ( */}
                        <div className={"d-flex justify-content-end mr-3 mb-3"}>
                          <div className={"d-flex mr-3"}>
                            <Form.Check
                              custom
                              id={"showTerminated"}
                              type="switch"
                              name="showTerminated"
                              autoFocus="off"
                              onChange={() => {
                                setIsNonCommunicationMapped(
                                  !isNonCommunicationMapped
                                );
                              }}
                              checked={isNonCommunicationMapped}
                              className="medium"
                            />{" "}
                            <span className="ml-3">
                              Non Mapped Communications
                            </span>
                          </div>
                          <div>
                            {!isNonCommunicationMapped
                              ? data.length
                              : filterEvents.length}{" "}
                            {typeName} found
                          </div>
                        </div>
                        {/* ) : null} */}
                        <div className="bodyContent">
                          {!isNonCommunicationMapped ? (
                            <div className="Non-card-labels">
                              {communictaionLables.map((lab) => {
                                return (
                                  <div className={lab.classname}>
                                    {" "}
                                    {lab.label}{" "}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="Non-card-non-mapped-labels">
                              {communictaionNotMappedLables.map((lab) => {
                                return (
                                  <div className={lab.classname}>
                                    {" "}
                                    {lab.label}{" "}
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          <InfiniteScroll
                            pageStart={0}
                            loadMore={() => {
                              append.current = true;
                              setRequest((prevRequest) => ({
                                ...prevRequest,
                                from: data?.length,
                              }));
                            }}
                            hasMore={!stopInfiniteScroll}
                            initialLoad={false}
                            //threshold={100}
                            useWindow={false}
                            loader={
                              <div className="loader" key={0}>
                                Loading ...
                              </div>
                            }
                          >
                            {!isNonCommunicationMapped && data.length > 0 ? (
                              data.map((x, ind) => {
                                return (
                                  <Link
                                    to={getPathWithParam({
                                      path: `${MANAGE_COMMUNICATION_ROUTES.CONFIGURE_COMMUNICATION}`,
                                      pathParam: [
                                        x.eventOrScheduleName,
                                        x.eventId,
                                        values[fields.planId],
                                      ],
                                    })}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <CommunicationCard
                                      isPlanLevelCommunication={true}
                                      isAllEvent={false}
                                      data={x}
                                      eventsList={eventsList}
                                    />
                                  </Link>
                                );
                              })
                            ) : // (
                            //   <span
                            //     style={{
                            //       margin: "auto",
                            //       textAlign: "center",
                            //       fontSize: "18px",
                            //       color: "#333333",
                            //       display: "block",
                            //     }}
                            //   >
                            //     No Records Found
                            //   </span>
                            // )

                            isNonCommunicationMapped &&
                              filterEvents.length > 0 ? (
                              filterEvents.map((selectedEvent, ind) => {
                                return (
                                  // <Link
                                  //   to={getPathWithParam({
                                  //     path: `${MANAGE_COMMUNICATION_ROUTES.CONFIGURE_COMMUNICATION}`,
                                  //     // pathParam: [
                                  //     //   selectedEvent.label,
                                  //     //   eventType,
                                  //     //   selectedPlan,
                                  //     //   channelForCommunication[x.channel],
                                  //     // ],
                                  //   })}
                                  //   style={{ textDecoration: "none" }}
                                  // >

                                  <CommunicationCard
                                    isPlanLevelCommunication={false}
                                    isAllEvent={true}
                                    data={selectedEvent}
                                    eventsList={eventsList}
                                  />
                                  // </Link>
                                );
                              })
                            ) : (
                              <span
                                style={{
                                  margin: "auto",
                                  textAlign: "center",
                                  fontSize: "18px",
                                  color: "#333333",
                                  display: "block",
                                }}
                              >
                                No Records Found
                              </span>
                            )}
                          </InfiniteScroll>
                        </div>
                      </div>
                    </Form>
                  </LoaderWrapper>
                );
              }}
            </Formik>
          </ManageCommunicationLayout>
        );
      }}
    </Formik>
  );
};

export default PlanLevelCommunicationContainer;
